import Services from "@/components/site/Services";
import ContactCTA from "@/components/site/ContactCTA";

export default function ServicesPage() {
  return (
    <main data-testid="page-services" className="pt-24">
      <section className="container-x pt-16 pb-8">
        <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
          / Services
        </div>
        <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight max-w-4xl leading-[1.02]">
          One studio.{" "}
          <span className="text-[#00F0FF]">Four disciplines.</span>
        </h1>
        <p className="mt-6 text-white/60 max-w-2xl leading-relaxed">
          From strategy through applied research to shipped software — we
          plug in wherever the leverage is highest.
        </p>
      </section>
      <Services />
      <ContactCTA />
    </main>
  );
}
